import { Decimal } from 'decimal.js';
import { z } from 'zod';

type ValueParser = (key: string, value: unknown) => unknown;

const parseDate: ValueParser = (_key, value) => {
  if (typeof value === 'string') {
    const result = z.iso.datetime().safeParse(value);
    if (result.success) return new Date(value);
  }
  return value;
};

const parseDecimal: ValueParser = (_key, value) => {
  if (
    value !== null &&
    typeof value === 'object' &&
    '_decimal' in value &&
    typeof value._decimal === 'string'
  )
    return new Decimal(value._decimal);

  return value;
};

const parsers: ValueParser[] = [parseDate, parseDecimal];

export function smartJSONParse(data: unknown) {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data, (key, value) =>
        parsers.reduce((currentValue, parser) => parser(key, currentValue), value)
      );
    } catch {
      return data;
    }
  }
  return data;
}
